import { Icon } from '@ps/isp-web-component-library';
import { ChevronMediumDown } from '@ps/isp-web-component-library/icons/ChevronMediumDown';
import classNames from 'clsx';
import React from 'react';

import styles from './Subtitle.scss';

interface Props {
  isOpen?: boolean;
}

const Subtitle: React.FC<React.PropsWithChildren<Props>> = ({ children, isOpen = false }) => (
  <div
    className={classNames(styles.titleWrapper, {
      [styles.open]: isOpen
    })}
  >
    <Icon icon={ChevronMediumDown} className={styles.icon} size="xs" />
    <div>{children}</div>
  </div>
);

export default Subtitle;
